import type { FaireProductEntity } from "../../entity_types/product";

export const p_449vg23vfm: FaireProductEntity = {
  token: "p_449vg23vfm",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Hoop Earrings - 7017",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/d0817939457562a1fd62344655a33d2ade09fb4991fc7df69f8bc6f6ef4e9d7f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/64212ef49b37a56b4fa29d4cac85f14d0e88794312384c6d6d2810f0bf2c0112.jpeg",
    "https://cdn.faire.com/fastly/277523c7cd6cdb20e947ab6bc07718b369c4cb0fd261a8dec04d62356a0f64ca.jpeg",
    "https://cdn.faire.com/fastly/ab2436fcade6f6d6d29ef518a95c433bac70c9cb78b28607cdf08dbac5ec1641.jpeg",
    "https://cdn.faire.com/fastly/ed32fc3be9a99878faaee9d9e0bc3900557f0838c6f26600f72694aa7d033c13.jpeg",
    "https://cdn.faire.com/fastly/57d8d1e96772bc0ee1ff64a1a1922a99264098aeab9e53db82fe659c568aa1b3.jpeg",
    "https://cdn.faire.com/fastly/1de718504c7b9c075cc2501d7051175ead49e1966579814ec53e79fe097a82d5.jpeg",
    "https://cdn.faire.com/fastly/44d9a0cf921690c74c536cf4d46618584d06d3e9d5e50b91f023c4b6041d4f7a.jpeg",
  ],
  priceDollars: 6.86,
  description:
    '18K Gold Dipped Stainless Steel Small C Hoop Earrings with Crystals.\nApprox. 0.75"L\n\n\n\nThese earrings are hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the gold plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n\n\n',
  tags: [],
  msrpDollars: 27.44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:08.052Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
